import QuantityProduct from './QuantityProduct'

class LocalAreaPhotoProduct extends QuantityProduct {}

export default LocalAreaPhotoProduct
